import React from 'react';
import { ExternalLink } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { name: 'Prospectus', url: 'https://www.davcommercesolapur.org/DAV/prospect.pdf' },
    { name: 'Syllabus', url: '#' },
    { name: 'Sports', url: '#' },
    { name: 'NCC', url: 'https://www.davcommercesolapur.org/DAV/ncc%20website%20Information.pdf' },
    { name: 'NSS', url: '/nss' },
    { name: 'Cultural Section', url: 'https://www.davcommercesolapur.org/DAV/CULTURAL%202020-2021.pdf' },
    { name: 'Career Guidance', url: '#' },
    { name: 'Past Students Association', url: '#' },
    { name: 'Counselling Cell', url: '#' },
    { name: 'Examinations', url: '#' },
    { name: 'Code of Conduct & Ethics', url: 'https://www.davcommercesolapur.org/DAV/Code%20of%20Professional%20Ethics%20DAV.pdf' },
    { name: 'Core Values', url: '#' },
    { name: 'Green & Energy Audit', url: 'https://www.davcommercesolapur.org/DAV/Energy%20Environment%20&%20Green%20Audit%20Report%20DAV%20Velankar%20Solapur.pdf' },
    { name: 'Gender Sensitization Action Plan', url: 'https://www.davcommercesolapur.org/DAV/gender%20sensitization%20action%20plan.pdf' },
    { name: 'Published Research Papers', url: '/research' },
    { name: 'Policy for Maintenance and Utilization', url: 'https://www.davcommercesolapur.org/DAV/Infrastructure%20Utilization%20policy.pdf' },
    { name: 'Best Practices', url: 'https://www.davcommercesolapur.org/DAV/Best%20Practice.pdf' },
    { name: 'Quality Mandate', url: 'https://www.ugc.ac.in/e-book/Quality%20Mandate%20E-BOOK.pdf' }
  ];

  const importantLinks = [
    { name: 'PAH Solapur University', url: 'https://su.digitaluniversity.ac/' },
    { name: 'University Grants Commission', url: 'https://www.ugc.ac.in/' },
    { name: 'RUSA', url: 'https://rusa.nic.in/' },
    { name: 'NAAC', url: 'https://naac.gov.in/index.php/en/' },
    { name: 'Scholarship', url: 'https://mahadbtmahait.gov.in/' },
    { name: 'SWAYAM', url: 'https://swayam.gov.in/' },
    { name: 'Sevaarth', url: 'https://sevaarth.mahakosh.gov.in/login.jsp' },
    { name: 'MPSC', url: 'https://mpsc.gov.in/' },
    { name: 'UPSC', url: 'https://upsc.gov.in/' },
    { name: 'IBPS', url: 'https://ibps.in/' }
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-800 to-gray-900 text-white pt-12 pb-6">
      <div className="container mx-auto px-4">
        {/* Quick Links Section */}
        <div className="mb-8">
          <h3 className="text-xl font-bold mb-4 text-[#FFD700]">Quick Links</h3>
          <div className="flex flex-wrap gap-2">
            {quickLinks.map((link, index) => (
              <React.Fragment key={index}>
                <a
                  href={link.url}
                  target={link.url.startsWith('http') ? '_blank' : '_self'}
                  rel="noopener noreferrer"
                  className="text-sm hover:text-[#FFD700] transition-colors inline-flex items-center gap-1"
                >
                  {link.name}
                  {link.url.startsWith('http') && <ExternalLink className="w-3 h-3" />}
                </a>
                {index < quickLinks.length - 1 && <span className="text-gray-500">|</span>}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Important Links Section */}
        <div className="mb-8">
          <h3 className="text-xl font-bold mb-4 text-[#FFD700]">Important Links</h3>
          <div className="flex flex-wrap gap-2">
            {importantLinks.map((link, index) => (
              <React.Fragment key={index}>
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm hover:text-[#FFD700] transition-colors inline-flex items-center gap-1"
                >
                  {link.name}
                  <ExternalLink className="w-3 h-3" />
                </a>
                {index < importantLinks.length - 1 && <span className="text-gray-500">|</span>}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 pt-6 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} D.A.V. Velankar College of Commerce, Solapur. All Rights Reserved.
          </p>
        </div>

        {/* Back to Top */}
        <div className="text-center mt-4">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-sm text-[#FFD700] hover:underline"
          >
            Click to return on the top page
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;